module.exports = __webpack_public_path__ + "img/featuredartist (1).2eab2eae.jpg";